const INITIAL_STATE = { eventName: '', eventDescription: '', eventLink: '', eventTime: '', eventMessage: '' };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'EVENT_NAME_CHANGE':
            return { ...state, eventName: action.payload };
        case 'EVENT_DESCRIPTION_CHANGE':
            return { ...state, eventDescription: action.payload };
        case 'EVENT_LINK_CHANGE':
            return { ...state, eventLink: action.payload };
        // case 'EVENT_TIME_CHANGE':
        //     return { ...state, eventTime: action.payload };
        case 'EVENT_MESSAGE_CHANGE':
            return { ...state, eventMessage: action.payload };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/Events/EventReducer.js